export const sectionTitleClass =
  'max-w-[24ch] text-3xl font-semibold tracking-tight text-content sm:text-4xl';
export const sectionLeadClass = 'mt-4 max-w-[55ch] text-lg text-muted';
